<ion-content>
  <ion-header>
    <ion-toolbar mode="ios">
      <ion-button
        (click)="close()"
        fill="clear"
        color="dark"
        class="ion-no-padding"
      >
        <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
      </ion-button>
      <ion-title class="ion-no-padding">
        <ion-img
          [src]="dataServ.rData.dark_logo"
          *ngIf="dataServ.rData && dataServ.rData.dark_logo[0]"
        ></ion-img>
      </ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-grid class="form">
    <ion-row>
      <ion-col size="12">
        <ion-text color="primary" class="ion-text-center">
          <h1>
            <b>{{ "Add New Accommodation" | translate }}</b>
          </h1>
        </ion-text>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12">
        <ion-item>
          <ion-label position="stacked"
            >{{ "Room No" | translate }}
            <ion-text color="danger">*</ion-text></ion-label
          >
          <ion-input [(ngModel)]="newData.room_no"></ion-input>
        </ion-item>
      </ion-col>
      <ion-col size="12">
        <ion-item>
          <ion-label position="stacked"
            >{{ "Check-in" | translate }}
            <ion-text color="danger">*</ion-text></ion-label
          >
          <ion-datetime
            display-format="DD.MM.YYYY"
            [(ngModel)]="newData.start_date"
            max="2025-12-30"
          ></ion-datetime>
        </ion-item>
      </ion-col>
      <ion-col size="12">
        <ion-item>
          <ion-label position="stacked">
            {{ "Check-out" | translate }}
            <ion-text color="danger">*</ion-text>
          </ion-label>
          <ion-datetime
            display-format="DD.MM.YYYY"
            [(ngModel)]="newData.end_date"
            max="2025-12-30"
          ></ion-datetime>
        </ion-item>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12">
        <ion-button (click)="save()" expand="block" color="primary" [disabled]="isSubmitting">
          <ion-spinner name="crescent" *ngIf="isSubmitting"></ion-spinner>
          <span *ngIf="!isSubmitting">{{ "Save" | translate }}</span>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
